import { Link, useLocation } from "react-router-dom";
import { Home, Calendar, Ticket, Gift } from "lucide-react";
import clsx from "clsx";

const TABS = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/programme", label: "Programme", Icon: Calendar },
  { to: "/book", label: "Book", Icon: Ticket },
  { to: "/invite", label: "Invite", Icon: Gift },
];

export default function MobileTabBar() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="mobile-tabbar"
      className="md:hidden fixed bottom-0 inset-x-0 bg-cream/95 backdrop-blur border-t border-[#EFE7D2] z-40"
    >
      <div className="flex items-center justify-around py-2">
        {TABS.map(({ to, label, Icon }) => {
          const active = pathname === to;
          return (
            <Link
              key={to}
              to={to}
              data-testid={`tab-${to === "/" ? "home" : to.slice(1)}`}
              className={clsx(
                "flex flex-col items-center gap-1 px-3 py-1",
                active ? "text-coral" : "text-grey"
              )}
            >
              <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
              <span className="text-[10px] font-bold tracking-wider uppercase">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
